(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wll-testimonials"] && !Shopify.designMode) return;
  try {
    
function initializeReviewRails(root) {
  root.querySelectorAll('.wll-reviews').forEach(section => {
    const viewport = section.querySelector('.wll-reviews__viewport');
    const controls = section.querySelector('[data-review-controls]');
    if (!controls || controls.dataset.initialized) return;
    controls.dataset.initialized = 'true';
    controls.hidden = false;
    viewport.scrollLeft = (viewport.scrollWidth - viewport.clientWidth) / 2;
    const buttons = controls.querySelectorAll('button');
    const update = () => {
      buttons[0].disabled = viewport.scrollLeft <= 1;
      buttons[1].disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
    };
    buttons.forEach(button => button.addEventListener('click', () => {
      const card = viewport.querySelector('.wll-review-card');
      viewport.scrollBy({left: Number(button.dataset.reviewDirection) * (card.getBoundingClientRect().width + 20), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }));
    viewport.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(viewport);
    update();
  });
}
initializeReviewRails(document);
document.addEventListener('shopify:section:load', event => initializeReviewRails(event.target));

  } catch(e) { console.error(e); }
})();
})();
